import { LOCATION_CHANGE, UPDATE_ROUTER } from "../constants";

export const initialRouterHistory: any = {};
const backButtonHist: any = [];
const backResultHist: any = [];
const backResultState: any = [];

export function routerHistory(state: any = initialRouterHistory, action: any) {
  switch (action.type) {
    case UPDATE_ROUTER:
      const updateRouter: any = { ...state };
      updateRouter[action.routerField] = action.routerValue;
      return updateRouter;
    case LOCATION_CHANGE:
      if (action.payload.location.state?.url) {
        backButtonHist.push(action.payload.location.state.url);
        return {
          backButtonHist,
        };
      }
      if (action.payload.location.state?.backResults) {
        backResultHist.push(action.payload.location.state.backResults);
        if (action.payload.location.state.appState) {
          backResultState.push(action.payload.location.state.appState);
        }
        return {
          backResultHist,
          backResultState,
        };
      }
  }

  return state;
}
